import { useQuery } from '@tanstack/react-query';
import type { DashboardResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

export function useDashboardQuery(scope: 'me' | 'team', days: number, enabled = true) {
  return useQuery({
    queryKey: ['dashboard', scope, days],
    queryFn: () => api.get<DashboardResponse>(`/dashboard?scope=${scope}&days=${days}`),
    enabled,
  });
}
